<template>
  <Modal
    :value="visible"
    @input="updateVisible"
    :contentClass="'py-4 px-6'"
    :show-close-button="false"
  >
    <template v-slot:header>
      <Typography variant="h-5"> Tax info is required </Typography>
    </template>
    <div class="text-left mt-4">
      <Typography variant="body-1" as="p">
        Because you've earned taxable rewards, we're required to collect tax info.
      </Typography>

      <div class="d-flex justify-end flex-row mt-6" style="gap: 16px">
        <Button text color="brandPrimary" @click="close"> I'LL DO THIS LATER </Button>
        <Button color="brandPrimary" @click="addTaxInfo"> ADD TAX INFO </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Modal from "@/components/generic/Modal.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "TaxInfoRequiredModal",
  components: {
    Button,
    Modal,
    Typography,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateVisible(value) {
      this.$emit("update:visible", value);
    },
    close() {
      this.updateVisible(false);
      this.$emit("later");
    },
    addTaxInfo() {
      this.$emit("add-tax-info");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
}
</style>
